export const tedeeConfig = {
  common: {
    saving: "جارٍ الحفظ...",
    connected: "متصل",
    disconnected: "غير متصل",
    lockFallbackNamed: "قفل {id}",
    deviceFallbackNamed: "جهاز Tedee {id}",
    unitFallback: "وحدة",
    unitFallbackNamed: "وحدة {id}",
  },

  credentials: {
    title: "إعداد Tedee",
    apiVersionInUse: "إصدار API المستخدم:",
    savedKey: "تم حفظ المفتاح",
    noKey: "بدون مفتاح",
    keyLabel: "Personal Access Key",
    keyPlaceholderSaved: "•••••••• (محفوظ، التغيير اختياري)",
    keyPlaceholderNew: "أدخل مفتاح الوصول الشخصي (Personal Access Key) الخاص بـ Tedee",
    keyHintSaved: "يمكنك تركه فارغًا إذا كان لديك مفتاح محفوظ بالفعل.",
    keyHintNew: "احصل على مفتاحك من بوابة Tedee.",
    testing: "جارٍ الاختبار...",
    test: "اختبار الاتصال",
    save: "حفظ بيانات الاعتماد",
  },

  selector: {
    title: "محدّد الأقفال لهذا العقار",
    subA: "اختر فقط الأقفال التي تنطبق على",
    subBold: "هذا العقار",
    subB: ". بعد ذلك سترى في نظام إدارة العقارات (PMS) الأقفال المحددة فقط.",
    selectedCount: "{count} محددة",
    hintNoKeyA: "أدخل مفتاح الوصول الشخصي (Personal Access Key) واضغط",
    hintNoKeyBold: "اختبار الاتصال",
    hintNoKeyB: "لتحميل أقفالك.",
    emptyDevices:
      "لم نعثر على أي قفل أو بوابة في حسابك على Tedee. تأكد من أن الجهاز مُسجَّل ومُشارَك مع الحساب الذي حفظت مفتاحه أعلاه.",
    placeholder: "اختر الأقفال…",
    summaryCount: "{count} قفل محدد",
    summaryEmpty: "لم يتم تحديد أي قفل",
    save: "حفظ أقفال هذا العقار",
  },

  pms: {
    title: "التحكم والتعيين (PMS)",
    subA:
      "تظهر هنا فقط الأقفال التي حفظتها لهذا العقار. عيّن كلًّا منها إلى",
    subBold1: "الباب الرئيسي",
    subOr: "أو",
    subBold2: "وحدة",
    subEnd: ".",
    assignedCount: "{count} مُعيَّنة",
    empty: {
      A: "ليس لديك أي أقفال محفوظة لهذا العقار بعد. استخدم",
      bold: "المحدّد",
      B: "بالأعلى ثم احفظ.",
    },
    assignmentLabel: "التعيين",
    assignmentNone: "غير مُعيَّن",
    assignmentGate: "الباب الرئيسي (Gate)",
    assignmentCommon: "الباب الرئيسي (مشترك)",
    assignmentUnit: "باب الشقة",
    hintNone: "لن يتم التحكم به من نظام إدارة العقارات (PMS).",
    hintGate: "Gate: يمكن الضغط عليه للفتح فقط (لا يدعم القفل/PIN).",
    hintUnit: "سيرتبط بهذا العقار من أجل التحكم/رموز PIN.",
    unitLabel: "الوحدة / مكان الإقامة",
    unitSelect: "اختر وحدة",
    unitHint: "اختر الوحدة التي يفتحها هذا القفل.",
    nameLabel: "الاسم (اختياري)",
    namePlaceholder: "مثال: الباب الرئيسي / شقة 101",
    nameHint: "يُحفظ هذا الاسم عند حفظ محدّد الأقفال مرة أخرى.",
    actions: {
      lock: "قفل",
      unlock: "فتح",
      createPin: "إنشاء PIN",
      pinHistory: "سجل رموز PIN",
      openGate: "فتح البوابة (نبضة)",
      refresh: "تحديث الحالة",
    },
    save: "حفظ التعيين",
    tipA: "نصيحة: عيّن بابًا رئيسيًا أو وحدة واضغط",
    tipBold: "حفظ التعيين",
    tipB: ". تُفعَّل الأزرار بمجرد تعيين الجهاز.",
  },

  pinHistory: {
    title: "سجل رموز PIN",
    loading: "جارٍ تحميل السجل…",
    empty: "لا توجد رموز PIN مسجلة لهذا القفل.",
    colAlias: "الاسم المستعار",
    colPin: "PIN",
    colValidity: "الصلاحية",
    colState: "الحالة",
    createdPrefix: "أُنشئ في:",
    fromLabel: "من:",
    toLabel: "إلى:",
    revokeTitle: "حذف / إبطال PIN",
    noteA: '* تُحتسب "الحالة النشطة" بمقارنة التاريخ/الوقت الحالي بـ',
    noteMid: "و",
    noteEnd: ".",
    close: "إغلاق",
  },

  pinModal: {
    title: "إنشاء PIN",
    nameLabel: "الاسم / التسمية",
    namePlaceholder: "مثال: تنظيف / ضيف / فني",
    pinLabel: "PIN",
    pinPlaceholder: "6 أرقام",
    generateTitle: "توليد",
    pinHint: "إذا تركته فارغًا، سيقوم الخادم بتوليد واحد.",
    modeLabel: "الوضع",
    modeTimeLimited: "بتواريخ",
    modeOngoing: "بدون تواريخ (حتى الإبطال)",
    validFrom: "صالح من",
    validTo: "صالح حتى",
    tipLabel: "نصيحة:",
    tipText: "للضيف، استخدم رمز PIN بتاريخي الوصول والمغادرة.",
    cancel: "إلغاء",
    creating: "جارٍ الإنشاء...",
    create: "إنشاء PIN",
  },

  toast: {
    noLocksFound: "لم يتم العثور على أقفال (type 2/5) في Tedee.",
    loadStatusError: "تعذّر تحميل حالة الأقفال",
    loadStatusError2: "خطأ في تحميل حالة الأقفال",
    needKey: "يجب إدخال Personal Access Key أو امتلاك مفتاح محفوظ.",
    connectionOk: "تم الاتصال بنجاح. تم العثور على {count} جهازًا.",
    testError: "خطأ أثناء اختبار الاتصال",
    needValidKey:
      "يجب إدخال Personal Access Key صالح (10 أحرف على الأقل).",
    credentialsSaved: "تم حفظ بيانات الاعتماد بنجاح",
    saveCredentialsError: "خطأ في حفظ بيانات الاعتماد",
    saveCredentialsErrorPrefix: "خطأ في حفظ بيانات الاعتماد: ",
    needOneDevice: "يجب اختيار جهاز واحد على الأقل لهذا العقار.",
    devicesSaved: "تم حفظ الأجهزة لهذا العقار",
    devicesSaveError: "تعذّر حفظ الأجهزة",
    saveErrorPrefix: "خطأ في الحفظ: ",
    gateNoLock:
      "Gate (type 5) لا يدعم القفل. يمكن الضغط عليه للفتح فقط.",
    locked: "تم قفل القفل",
    lockError: "تعذّر القفل",
    lockError2: "خطأ في القفل",
    gateOpened: "تم فتح البوابة (نبضة)",
    unlocked: "تم فتح القفل",
    unlockError: "تعذّر الفتح",
    unlockError2: "خطأ في الفتح",
    needUnitForApartment:
      "اختر الوحدة للأقفال المعيَّنة كـ 'باب الشقة'.",
    bindingsSaved: "تم حفظ التعيين بنجاح",
    bindingsSaveError: "تعذّر حفظ التعيين",
    bindingsSaveErrorPrefix: "خطأ في حفظ التعيين: ",
    gateNoPin: "Gate (type 5) لا يدعم رموز PIN.",
    assignFirst:
      "عيّن القفل أولًا (الباب الرئيسي أو الوحدة) واحفظ لتفعيل التحكم.",
    needPinName: "يجب تحديد اسم/تسمية لرمز PIN.",
    needValidDates: "يجب تحديد صالح من وصالح حتى.",
    pinCreated: "تم إنشاء PIN بنجاح",
    pinCreateError: "تعذّر إنشاء PIN",
    pinCreateError2: "خطأ في إنشاء PIN",
    gateNoPinHistory: "Gate (type 5) لا يدعم سجل رموز PIN.",
    historyLoadError: "تعذّر تحميل السجل",
    historyLoadError2: "خطأ في تحميل السجل",
    noProviderPinId:
      "رمز PIN هذا لا يحتوي على provider_pin_id. لا يمكن إبطاله في Tedee.",
    pinRevoked: "تم إبطال PIN",
    revokeError: "تعذّر الإبطال",
    revokeError2: "خطأ في إبطال PIN",
  },

  confirm: {
    revokePin: 'هل أنت متأكد أنك تريد إبطال/حذف رمز PIN "{alias}"؟',
  },

  pinState: {
    active: "نشط",
    upcoming: "قادم",
    expired: "منتهٍ",
    revoked: "مُبطَل",
    none: "بدون تواريخ",
  },
};
